import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';

import Button from 'Components/LegacyButton';
import TextField from 'Components/TextField';
import Typography from 'Components/Typography';

import BaseScene from 'Scenes/LegacyBaseScene';

const styles = {
  emailField: {
    width: '100%',
    maxWidth: 400,
  },
};

const Signin = ({
  classes,
  email,
  error,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  isValidLogin,
}) => {
  return (
    <form onSubmit={handleSubmit}>
      <BaseScene background="beige" header padding>
        <Typography align="center" markupName="h2" variant="h1">
          Log in as an existing customer
        </Typography>

        <TextField
          className={classes.emailField}
          error={error}
          id="email"
          label="Email address"
          margin
          name="email"
          onBlur={handleBlur}
          onChange={handleChange}
          type="email"
          value={email}
        />

        <Button disabled={isSubmitting || !isValidLogin} isLoading={isSubmitting} type="submit">
          Login
        </Button>

        <Typography align="center" color="noir" variant="p1">
          New to Prose?
        </Typography>

        <Button Component="a" href="/consultation" variant="underlined">
          Start a consultation
        </Button>
      </BaseScene>
    </form>
  );
};

Signin.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  email: PropTypes.string.isRequired,
  error: PropTypes.string,
  handleBlur: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  isValidLogin: PropTypes.bool.isRequired,
};

export default withStyles(styles)(Signin);
